"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
var _default = isReactNative;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/isReactNative.js
// module id = 439
// module chunks = 0